module.exports = __webpack_public_path__ + "img/businesswoman-use-laptop.6b0a8b73.jpeg";